import { Button, ChakraAsyncSelect, FormControl, FormLabel, HStack, Stack, useBoolean, useDisclosure } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { BaseFilterButton } from 'components/base-table/filters';
import { usePageParams } from 'hooks/use-page-params';
import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';

type TOption = { value: string; label: string };
type TInputs = { restaurantId: TOption | undefined };

export const InvoiceScanRestaurantFilterButton = () => {
  const [isActive, setIsActive] = useBoolean(false);
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { getPageParams, setPageParams } = usePageParams();
  const params = getPageParams();

  useEffect(() => {
    if (params.restaurantId) setIsActive.on();
    else setIsActive.off();
  }, [params.restaurantId]);

  const { control, handleSubmit, formState, reset, setValue } = useForm<TInputs>({
    defaultValues: { restaurantId: undefined },
  });

  const updateValues = () => {
    setValue('restaurantId', undefined);
  };

  useEffect(() => {
    updateValues();
  }, [params.restaurantId]);

  const onSubmit = (data: TInputs) => {
    params.restaurantId = data.restaurantId?.value as string;
    setPageParams(params);
    onClose();
    reset(data);
  };

  const handleClose = () => {
    onClose();
    updateValues();
  };

  return (
    <BaseFilterButton
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={handleClose}
      isActive={isActive}
      formComponent={
        <Stack as='form' spacing='lg' p='md' pt='lg' onSubmit={handleSubmit(onSubmit)}>
          <Controller
            control={control}
            name='restaurantId'
            render={({ field: { onChange, name, onBlur, value } }) => (
              <FormControl>
                <FormLabel>Restaurant</FormLabel>
                <ChakraAsyncSelect
                  id='restaurantId'
                  onChange={onChange}
                  name={name}
                  onBlur={onBlur}
                  value={value}
                  loadOptions={(inputValue, callback) => {
                    http
                      .get('restaurants', {
                        params: { filter: `nameEn||$contL||${inputValue}` },
                      })
                      .then((res) => {
                        const values: TOption[] = (res?.data?.data || []).map((item: any) => ({
                          value: item?.id,
                          label: item?.nameEn,
                        }));
                        callback(values);
                      });
                  }}
                />
              </FormControl>
            )}
          />
          <HStack justify='flex-end'>
            <Button variant='outline' colorScheme='red' onClick={handleClose}>Cancel</Button>
            <Button variant='solid' colorScheme='red' type='submit' disabled={!Object.keys(formState.dirtyFields).length}>Filter</Button>
          </HStack>
        </Stack>
      }
    />
  );
};
